import styled from "styled-components";

type CalendarViewMode = "month" | "week" | "talhao" | "janela-execucao";

const isMonthLike = (viewMode: CalendarViewMode) =>
  viewMode === "month" || viewMode === "janela-execucao";

export const Container = styled.div<{ $viewMode: CalendarViewMode }>`
  width: 100%;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  /* height: 85vh; */
  height:  ${({ $viewMode }) =>
    isMonthLike($viewMode) ? "calc(100vh - 240px)" : "auto"};

  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  /* overflow: hidden; */
`;

export const HeaderRow = styled.div<{
  $viewMode: CalendarViewMode;
  $scrollbarWidth?: number;
}>`
  display: grid;
  grid-template-columns: ${({ $viewMode }) =>
    $viewMode === "talhao" ? "repeat(8, 1fr)" : "repeat(7, 1fr)"};
  background-color: #12619C;
  box-sizing: border-box;

  ${({ $viewMode, $scrollbarWidth = 0 }) =>
    $viewMode === "talhao" &&
    $scrollbarWidth > 0 &&
    `
    padding-right: ${$scrollbarWidth}px;
  `}
`;

export const HeaderCell = styled.div`
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 10px 6px;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
`;

export const HeaderDayMonth = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
`;

export const ContainerStatus = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-self: center;
  overflow: hidden;
`;

export const Status = styled.span<{ color?: string }>`
  font-weight: 500;
  font-size: 11px;
  line-height: 1.4;

  color: ${({ color }) => color};
`;

export const DaysGrid = styled.div<{ $viewMode: CalendarViewMode; $weeksInMonth?: number }>`
  flex: 1;
  min-height: ${({ $viewMode }) => (isMonthLike($viewMode) ? "0" : "max-content")};
  flex-shrink: ${({ $viewMode }) => (isMonthLike($viewMode) ? "1" : "0")};
  display: grid;
  grid-template-columns: ${({ $viewMode }) =>
    $viewMode === "talhao" ? "repeat(8, 1fr)" : "repeat(7, 1fr)"};
  grid-template-rows: ${({ $viewMode, $weeksInMonth = 5 }) =>
    isMonthLike($viewMode) ? `repeat(${$weeksInMonth}, 1fr)` : "repeat(1, 1fr)"};
`;

export const JanelaBarsContainer = styled.div`
  position: absolute;
  left: 4px;
  right: 4px;
  top: 28px;
  bottom: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  overflow: hidden;
`;

export const JanelaBar = styled.div<{
  $color: string;
  $variant: "single" | "start" | "end" | "continuation";
  $empty?: boolean;
}>`
  height: calc((100% - (5 - 1) * 9px) / 5);
  /* min-height: 14px; */
  flex-shrink: 0;
  opacity: ${({ $empty }) => ($empty ? 0 : 0.55)};
  pointer-events: ${({ $empty }) => ($empty ? "none" : "auto")};
  background: ${({ $color, $empty }) => ($empty ? "transparent" : $color)};
  border-radius: ${({ $variant }) => {
    if ($variant === "single") return "3px";
    if ($variant === "start") return "3px 0 0 3px";
    if ($variant === "end") return "0 3px 3px 0";
    return "0";
  }};
  transition: opacity 0.12s;
`;

export const DayCell = styled.div<{
  $isCurrentMonth: boolean;
  today?: boolean;
  todayCurrent?: boolean;
  $viewMode: CalendarViewMode;
  $weeksInMonth?: number;
  $last?: boolean;
  $isClicked?: boolean;
}>`
  position: relative;
  height: ${({ $viewMode }) =>
    !isMonthLike($viewMode) ? "110px" : "auto"};
  display: grid;
  padding: ${({ $viewMode, $weeksInMonth = 5 }) =>
    isMonthLike($viewMode) && $weeksInMonth >= 6 ? "6px 8px" : "8px 10px"};

  border-bottom: 1px solid #eeeeee;

   ${({ today, $viewMode }) =>
    today && $viewMode !== "talhao" &&
    `
    border-bottom: 1px solid #12619C;
  `}

    ${({ $viewMode, $last }) =>
    $viewMode === "talhao" && $last &&
    `
    border-bottom: 1px solid #12619C;
  `}
  
  
  border-right: ${({ today, $viewMode }) => (today && $viewMode !== "talhao"  ? "1px solid #12619C" : "1px solid #eeeeee")};
  border-top: ${({ todayCurrent, $viewMode }) => (todayCurrent && $viewMode !== "talhao"  ? "1px solid #12619C" : "none")};
  border-left: ${({ todayCurrent }) => (todayCurrent  ? "1px solid #12619C" : "none")};
  font-size: ${({ $viewMode, $weeksInMonth = 5 }) =>
    isMonthLike($viewMode) && $weeksInMonth >= 6 ? "12px" : "14px"};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  color: ${({ $isCurrentMonth }) => ($isCurrentMonth ? "#1f1f1f" : "#8c8c8c")};
  background-color: ${({ $isCurrentMonth }) =>
    $isCurrentMonth ? "#ffffff" : "#fafafa"};
  font-weight: ${({ $isCurrentMonth }) => ($isCurrentMonth ? 600 : 400)};
  cursor: ${({ $isClicked }) => ($isClicked ? "pointer" : "normal")};

  ${({ $viewMode, $weeksInMonth = 5 }) =>
    isMonthLike($viewMode) &&
    $weeksInMonth >= 6 &&
    `
    ${ContainerStatus} {
      gap: 2px;
    }

    ${Status} {
      font-size: 9px;
      line-height: 1.2;
    }
      
    &:nth-child(7n) {
      border-right: none;
    }
  `}



  &:hover {
    background: #f5f5f5;
    border-right: ${({ today, $viewMode }) => (today && $viewMode !== "talhao" ? "1px solid #12619C" : "1px solid #eeeeee")};
    transform: ${({ $viewMode }) =>
    isMonthLike($viewMode) ? "scale(1.02)" : "none"};
    z-index: 99;

    ${JanelaBar}:not([data-empty="true"]) {
      opacity: 0.6;
    }
  }
`;

export const TalhaoCell = styled(DayCell).attrs({ $isCurrentMonth: true, $viewMode: "talhao" })`
  align-items: center;
  justify-content: center;
`;

export const WrapperDaysGrid = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  max-height: calc(100vh - 400px);
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;

  display: flex;
  flex-direction: column;
`;

export const ContainerStatusTooltip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CardColor = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  width: 12px;
  height: 12px;
`;

export const SpanCounter = styled.span`
  text-align: center;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.4;
`;